import RenderIf from "common/components/RenderIf";
import ProfileImage from "common/components/ui/ProfileImage";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { WorkspaceAccount } from "common/types";

const MAX_ACCOUNTS = 10;

export default function LicenseAccounts({
  accounts,
}: {
  accounts: WorkspaceAccount[];
}) {
  const isDesktop = useTwBreakpoint("lg");
  return (
    <Tooltip>
      <TooltipTrigger className="flex -space-x-2.5">
        {accounts
          .slice(0, MAX_ACCOUNTS)
          .map(({ id, full_name, picture_url }) => (
            <ProfileImage
              key={id}
              src={picture_url}
              alt={full_name}
              size="xs"
              className="ring-1 ring-white"
            />
          ))}

        <RenderIf condition={accounts.length > MAX_ACCOUNTS}>
          <span className="inline-flex ring-1 ring-white bg-purple-100 size-6 rounded-full items-center justify-center text-purple-600 text-xxs-bold">
            +{accounts.length - MAX_ACCOUNTS}
          </span>
        </RenderIf>
      </TooltipTrigger>

      <TooltipContent side={isDesktop ? "right" : "top"}>
        <div className="flex flex-col gap-y-1.5 max-h-60 overflow-y-auto scrollbar-thin -my-4 py-4">
          {accounts.map(({ id, picture_url, full_name }) => (
            <div key={id} className="flex items-center gap-x-1">
              <ProfileImage size="2xs" src={picture_url} />
              <span className="text-xs">{full_name}</span>
            </div>
          ))}
        </div>
      </TooltipContent>
    </Tooltip>
  );
}
